import React from "react";
import "./Video_Wala_Bus_Stand_content.css";

function Video_Wala_Bus_Stand_content() {
  return (
    <>
      <section className="Video_Wala_Bus_Stand">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-md-7 col-sm-7  order-sm-1 order-2  p-0">
              <div className="text-content">
              <div>

                <h4>Videowala Bus Stand</h4>

                <div className="p_tag_div">
                  <p>
                  Videowala Bus Stand is a game-changing advertising platform offered by ReachOut Media, designed to help businesses connect with millions of potential
                    customers daily. By strategically utilizing the bustling activity of bus stands across Maharashtra, this innovative medium turns transit hubs into
                    dynamic and engaging advertising zones.
                  </p>
                </div>
              </div>

              <hr className="hr_line_holder" />

                <div className="second_p_tag_div">
                 
                  <p>
                    This platform goes beyond traditional advertising methods, combining cutting-edge technology, strategic placement, and a massive audience
                    reach to deliver unparalleled brand visibility. Whether you're a small business, a growing startup, or an esta-blished corporation, Video
                    Wala Bus Stand offers you a unique way to promote your brand with maximum impact.
                  </p>
                </div>

              </div>
            </div>

            <div className="col-xl-5 col-md-5  col-sm-5 col-6  order-sm-2 order-1 p-0 video_col_holder">
              <div className="img-holder">
                <img
                  className="vdo-wala-inner-img"
                  src="/Assets/Images/Service/Services/Video_Wala_Bus_Stand/rightimg.png"
                  alt="vdo-wala-inner-img"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Video_Wala_Bus_Stand_content;
